export const NAME = 'myprofile';

export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
export const SUCCESS_UPDATE_PROFILE = 'SUCCESS_UPDATE_PROFILE';
export const FAILURE_UPDATE_PROFILE = 'FAILURE_UPDATE_PROFILE';

export const RESET_FORM_SUBMIT_UPDATE_PROFILE = 'RESET_FORM_SUBMIT_UPDATE_PROFILE';



// WEBPACK FOOTER //
// ./src/services/account/myprofile/constants.js